import { abortIfNotPermitted } from '../../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "supplier" */ '@js/franchise_component/franchise-inventory/supplier/supplier-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_supplier',
                next,
            );
        },
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "supplier" */ '@js/franchise_component/franchise-inventory/supplier/supplier-create.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_inventory_supplier',
                next,
            );
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "supplier" */ '@js/franchise_component/franchise-inventory/supplier/supplier-edit.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_supplier',
                next,
            );
        },
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/franchise-inventory/supplier.js